/**
 * Canonical, fixed list of equipment that can be assigned to an Operator
 * team member. This list is intentionally closed: users cannot add custom
 * equipment from the Add/Edit Team Member form.
 */
export const TEAM_MEMBER_EQUIPMENT_OPTIONS = [
  'M300',
  'M500',
  'IWM',
  'P600z',
  'P625',
  'Manual Welding',
  'Semi-Automatic Welding'
] as const
